var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-upload',{attrs:{"add-files-text":_vm.addFilesText,"duplicate-check":false,"hide-dropzone":true,"schema":_vm.model,"accept":_vm.accept,"max-size":_vm.maxSize},on:{"fileAdded":_vm.createAttachment}})}
var staticRenderFns = []

export { render, staticRenderFns }